import { ROUTES } from "@src/common/constants";
import { graduateFromBetaMutationFn } from "@src/components/plan/mutations/graduate-from-beta";
import { SupportedPlan } from "@src/gql/graphql";
import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useMyPlan } from "./queries/fetch-plan";

export function PostLoginGraduation() {
	const graduationCheckedRef = useRef(false);
	const navigate = useNavigate();
	const location = useLocation();
	const { data: currentPlan } = useMyPlan();

	useEffect(() => {
		const shouldRunGraduation =
			location.pathname !== ROUTES.checkoutReturn &&
			!graduationCheckedRef.current &&
			currentPlan?.plan === SupportedPlan.Pro;

		if (!shouldRunGraduation) {
			return;
		}
		graduationCheckedRef.current = true;

		async function runGraduation() {
			const result = await graduateFromBetaMutationFn();
			if (result?.wasMigrated !== true) {
				return;
			}
			navigate(`${ROUTES.checkoutReturn}?graduated=true`, { replace: true });
		}

		runGraduation().catch((error) => {
			graduationCheckedRef.current = false;
			console.error("[post-auth] Failed to graduate beta user", error);
		});
	}, [currentPlan?.plan, location.pathname, navigate]);

	return null;
}
